"use strict";
/**
 * @name Breadcrumbs
 *
 * @description
 *  A breadcrumbs component that will render the appropriate styles for breadcrumbs.
 *
 *
 * @example
 *  <Breadcrumbs breadcrumbs={breadcrumbs} home={home} />
 *
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
    style: PropTypes.object,
    separator: PropTypes.node,
    testId: PropTypes.string,
};
var Breadcrumbs = function (_a) {
    var className = _a.className, breadcrumbs = _a.breadcrumbs, id = _a.id, style = _a.style, separator = _a.separator, testId = _a.testId;
    var Separator = function () { return React.createElement(React.Fragment, null, separator); };
    var renderSeparator = function () {
        return (React.createElement("li", null,
            React.createElement(Separator, null)));
    };
    var renderCrumb = function (crumb) {
        var Crumb = function () { return React.createElement(React.Fragment, null, crumb); };
        return (React.createElement("li", null,
            React.createElement(Crumb, null)));
    };
    var renderBreadcrumbs = function () {
        if (!breadcrumbs) {
            return null;
        }
        return breadcrumbs.map(function (crumb, idx) {
            return (React.createElement(React.Fragment, { key: "breadcrumb_" + idx },
                renderCrumb(crumb),
                idx !== breadcrumbs.length - 1 && renderSeparator()));
        });
    };
    return (React.createElement("nav", { id: id, "aria-label": "Breadcrumb", className: className !== null && className !== void 0 ? className : 'Nav-breadcrumb', style: style, "data-testid": testId },
        React.createElement("ul", { className: "Breadcrumb" }, renderBreadcrumbs())));
};
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = {
    className: null,
    id: null,
    style: null,
    separator: React.createElement(Icon_1.default, { className: "Icon Icon-separator", name: "right" }),
    testId: null,
};
exports.default = Breadcrumbs;
